import styled from "@emotion/styled";
import { TableCell, Theme } from "@mui/material";

export const NoDataTableCell = styled(TableCell)<{ theme: Theme }>(
  ({ theme }) => ({
    // TODO: for example: check for design
    backgroundColor: theme.palette.background.paper,
    textAlign: "center",
  })
);
